import styled, { css } from 'styled-components';
import { rem } from '~/src/helpers/rem-converter.helper';
import { BORDER_RADIUS } from '~/src/styles/tokens/border-radius';
import { COLORS } from '~/src/styles/tokens/colors';
import { FONTS } from '~/src/styles/style-helpers/font-helper';

export const techAbilityPlankStyles = css`
    display: inline-flex;
    min-height: ${rem(36)};
    align-items: center;
    box-sizing: border-box;
`;

export const TechAbilityPlankContainer = styled.span`
    display: flex;
    gap: ${rem(8)};
    flex-wrap: wrap;
    margin-top: ${rem(24)};
`;

export const Content = styled.span`
    gap: ${rem(8)};
    align-items: center;
    flex-wrap: nowrap;
`;

export const Address = styled.b`
    display: contents;
    ${FONTS.compact.medium.size14};
`;

export const RetryTechAbilityButton = styled.span`
    ${techAbilityPlankStyles};
    border-radius: ${BORDER_RADIUS.medium6};
    padding: ${rem(6)} ${rem(12)};
    background-color: ${COLORS.controlsLightTertiaryActive};
    cursor: pointer;
    ${FONTS.compact.medium.size14};
`;
